import {
  RumXhrResourceEventDomainContext,
  datadogRum
} from '@datadog/browser-rum';
import Cookies from 'js-cookie';
import accessToken from '|/helpers/access-token';

const COOKIES = {
  dataDogSampling: '_dd_s'
};

function checkIsSampled(): boolean {
  const samplingCookie = Cookies.get(COOKIES.dataDogSampling);
  return (
    !samplingCookie ||
    samplingCookie.includes('rum=0') ||
    samplingCookie.includes('rum=2')
  );
}

if (checkIsSampled()) {
  Cookies.remove(COOKIES.dataDogSampling);
}

datadogRum.init({
  applicationId: 'bc7fb6cc-d24a-48c8-9722-f2ce30b35402',
  clientToken: 'pub6bf64308e6574813f395ad9a5c3f2c98',
  env: process.env.NODE_ENV,
  site: 'datadoghq.com',
  service: 'purchase-ui',
  version: process.env.APP_VERSION,
  sampleRate: 100,
  premiumSampleRate: 100,
  trackInteractions: true,
  trackFrustrations: true,
  actionNameAttribute: 'data-analytics-id',
  defaultPrivacyLevel: 'mask-user-input',
  trackViewsManually: false,
  beforeSend: (event, context) => {
    try {
      if (event.type === 'resource') {
        const { xhr } = context as RumXhrResourceEventDomainContext;
        const correlationId = xhr?.headers?.['correlation-id']?.[0];
        if (correlationId) {
          event.context = {
            ...event.context,
            correlationId
          };
        }
      }
      if (event.type === 'error' && event.error.source === 'console') {
        const isChatUiError = event.error.handling_stack?.includes(
          'googleapis'
        );
        event.context = {
          ...event.context,
          isChatUiError
        };
      }
      if (event.type === 'error' && event.error.message === 'Script error.') {
        return false;
      }
    } catch (e) {
      console.error(e);
    }
  }
});

datadogRum.setUser({
  // must use id since datadog's queryable columns are not dynamic
  id: accessToken()?.user?.user_id,
  userBcid: Cookies.get('BrowserCookieId')
});

datadogRum.startSessionReplayRecording();
